import SwiperCore, { Keyboard, Navigation } from 'swiper';
import Swiper from 'swiper';

export function productSlider() {
  const $slider = $('.product-head-slider');
  if (!$slider || $slider.length === 0) return;

  SwiperCore.use([Navigation, Keyboard]);

  const swiper = new Swiper('.product-head-slider', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.product-head-slider-next',
      prevEl: '.product-head-slider-prev',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });
}
